import { render, staticRenderFns } from "./tai-xiu-dice-row.vue?vue&type=template&id=5256760c&scoped=true"
import script from "./tai-xiu-dice-row.vue?vue&type=script&lang=js"
export * from "./tai-xiu-dice-row.vue?vue&type=script&lang=js"
import style0 from "./tai-xiu-dice-row.vue?vue&type=style&index=0&id=5256760c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5256760c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5256760c')) {
      api.createRecord('5256760c', component.options)
    } else {
      api.reload('5256760c', component.options)
    }
    module.hot.accept("./tai-xiu-dice-row.vue?vue&type=template&id=5256760c&scoped=true", function () {
      api.rerender('5256760c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tai-xiu/tai-xiu-dice-row.vue"
export default component.exports